/**
 * OAuth callback page for Parqet: exchange code for tokens, store, redirect to Schritt 2.
 */

import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Container, Header, Alert, Spinner, Box } from '@cloudscape-design/components';
import {
  exchangeCodeForToken,
  setStoredTokens,
  clearStoredState,
  getStoredState,
} from '@/services/parqetService';

/** Prevents double execution under React Strict Mode (effect runs twice in dev). */
let tokenExchangeInProgress = false;

const ParqetCallback: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const code = searchParams.get('code');
    const state = searchParams.get('state');
    const storedState = getStoredState();

    if (!code) {
      queueMicrotask(() => setError('Kein Autorisierungscode erhalten. Bitte Anmeldung erneut starten.'));
      return;
    }
    if (!state || state !== storedState) {
      queueMicrotask(() => setError('Ungültiger State (CSRF). Bitte Anmeldung erneut starten.'));
      clearStoredState();
      return;
    }
    if (tokenExchangeInProgress) return;
    tokenExchangeInProgress = true;

    let cancelled = false;
    exchangeCodeForToken(code)
      .then((data) => {
        clearStoredState();
        setStoredTokens(data);
        navigate('/schritt2', { replace: true });
      })
      .catch((err) => {
        if (cancelled) return;
        setError(err instanceof Error ? err.message : 'Token-Austausch fehlgeschlagen.');
      })
      .finally(() => {
        tokenExchangeInProgress = false;
      });

    return () => {
      cancelled = true;
    };
  }, [searchParams, navigate]);

  if (error) {
    return (
      <Container
        header={
          <Header variant="h2">
            Parqet-Anmeldung
          </Header>
        }
      >
        <Alert type="error" header="Fehler">
          {error}
        </Alert>
        <Box margin={{ top: 'm' }}>
          <a href="/schritt2">Zurück zu Schritt 2</a>
        </Box>
      </Container>
    );
  }

  return (
    <Container
      header={
        <Header variant="h2">
          Parqet-Anmeldung
        </Header>
      }
    >
      <Spinner />
      <Box variant="p">Anmeldung wird abgeschlossen…</Box>
    </Container>
  );
};

export default ParqetCallback;
